import { render, staticRenderFns } from "./AncillariesAutomatedOffer.vue?vue&type=template&id=49d96060&scoped=true"
import script from "./AncillariesAutomatedOffer.vue?vue&type=script&lang=js"
export * from "./AncillariesAutomatedOffer.vue?vue&type=script&lang=js"
import style0 from "./AncillariesAutomatedOffer.vue?vue&type=style&index=0&id=49d96060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d96060",
  null
  
)

export default component.exports